import {Component, OnInit} from '@angular/core';
import {OrderImport} from '../../../../dto/order-import';
import {OrderImportError} from '../../../../dto/order-import-error';
import {OrderImportsService} from '../../../services/order-imports.service';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateFormats, formatPhoneNumeric} from '../../../../providers/app-date-adapter';
import {Order} from '../../../../dto/order';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-order-import-view',
  templateUrl: './order-import-view.component.html',
  styleUrls: ['./order-import-view.component.css']
})
export class OrderImportViewComponent implements OnInit {
  import: OrderImport;

  importDataDataSource: MatTableDataSource<Order>;
  importErrorsDataSource:  MatTableDataSource<OrderImportError>;

  importCols = [
    { header: 'ID',           cell: (row: OrderImport) => `${row.id}`},
    { header: 'Date',         cell: (row: OrderImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime)}`},
    { header: 'User',         cell: (row: OrderImport) => `${row.username}`},
    { header: 'Invalid rows', cell: (row: OrderImport) => `${row.invalidRowCount}`},
    { header: 'Total rows',   cell: (row: OrderImport) => `${row.totalRowCount}`},
  ];

  importDataCols = [
    { columnDef: 'sex',            header: 'Sex',           cell: (row: Order) => `${row.sex}` },
    { columnDef: 'title',          header: 'Title',         cell: (row: Order) => `${row.title}`},
    { columnDef: 'firstName',      header: 'First name',    cell: (row: Order) => `${row.firstName}`},
    { columnDef: 'lastName',       header: 'Last name',     cell: (row: Order) => `${row.lastName}`},
    { columnDef: 'dob',            header: 'Date of birth', cell: (row: Order) => `${this.datePipe.transform(row.dob, DateFormats.DisplayDate)}`},
    { columnDef: 'address',        header: 'Address',       cell: (row: Order) => `${row.address}` },
    { columnDef: 'city',           header: 'City',          cell: (row: Order) => `${row.city}` },
    { columnDef: 'country',        header: 'Country',       cell: (row: Order) => `${row.countryName}` },
    { columnDef: 'email',          header: 'Email',         cell: (row: Order) => `${row.email}` },
    { columnDef: 'nationality',    header: 'Nationality',   cell: (row: Order) => `${row.nationality}` },
    { columnDef: 'phone',          header: 'Mobile',         cell: (row: Order) => `${formatPhoneNumeric(row.phone)}` },
    { columnDef: 'zipcode',        header: 'Zipcode',       cell: (row: Order) => `${row.zipCode}` },
    { columnDef: 'ipAddress',      header: 'Ip address',    cell: (row: Order) => `${row.ipAddress}` },
    { columnDef: 'productName',    header: 'Product name',  cell: (row: Order) => `${row.productName}` },
    { columnDef: 'orderDate',      header: 'Order date',    cell: (row: Order) => `${this.datePipe.transform(row.orderDate, DateFormats.DisplayDate)}` },
    { columnDef: 'pcId',    header: 'PartnerCustomerId',  cell: (row: Order) => `${row.partnerCustomerId}` },
  ];

  importErrorsCols = [
    { columnDef: 'rowNumber',   header: 'Row number',   cell: (row: OrderImportError) => `${row.rowNumber}`},
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: (row: OrderImportError) => `${row.parsedValue}`},
    { columnDef: 'errorText',   header: 'Error Text',   cell: (row: OrderImportError) => `${row.errorText}`},

  ];

  constructor(
    private importService: OrderImportsService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
      const id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.importService.get(id).subscribe(result => {
        this.import = result;
        this.importDataDataSource = new MatTableDataSource(result.orders);
        this.importErrorsDataSource = new MatTableDataSource(result.importErrors);
    });
  }

  getViewLink = (item: Order): string => '/orders/' + item.id.toString();
}
